import { mapGetters } from 'vuex'
import allIcon from '@/core/icons'
export default {
  //  app.vue页面定义
  // inject: ['reload'],
  // provide () {
  //   return {
  //     reload: this.reload
  //   }
  //  },
  data() {
    return {
      allIcon,
      // editAmisSchema:null
      scrollY: 525,
      layoutValue: 'inline',
      advanced: false
    }
  },
  computed: {
    ...mapGetters(['permissions', 'editAmisSchema', 'saveAmisSchema', 'menuHidden', 'multilevelMenuId', 'defaultRoutePath']),
  },
  mounted() {
    this.setTableScrollY()
    window.onresize = () => {
      // console.log('onresize>>>>>>')

      this.setTableScrollY()
    }
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced
      this.setTableScrollY()
    },
    /**
     * @desc 设置表格的高度和scroll
     * @param {  }
     * @version: 1.0.0
     */
    setTableScrollY() {
      // console.log('设置表格的高度和scroll>>>>')

      this.$nextTick(() => {
        if (document.querySelector('.ant-table')) {
          const scrollY = document.body.clientHeight - document.querySelector('.ant-table').getBoundingClientRect().top - 120
          this.$set(this, 'scrollY', scrollY)
          // console.log('页面>>>>mounted>>>>scrollY>>>>1', this.scrollY)
          // console.log('页面>>>>>onresize>>>>mounted>>>>scrollY>>>>offsetTop>>>>>1', document.querySelector('.ant-table').getBoundingClientRect().top)
          document.querySelector('.ant-table').style.height = `${this.scrollY + 46}px`
          document.querySelector('.ant-table-body').style.height = `${this.scrollY + 46 - 62}px`
        }
        // if (document.querySelector('.antd-Table-content')) {
        //   const scrollY = document.body.clientHeight - document.querySelector('.antd-Table-content').getBoundingClientRect().top - 120
        //   this.$set(this, 'scrollY', scrollY)
        //   // console.log('页面>>>>mounted>>>>scrollY>>>>1', this.scrollY)
        //   // console.log('页面>>>>>onresize>>>>mounted>>>>scrollY>>>>offsetTop>>>>>1', document.querySelector('.ant-table').getBoundingClientRect().top)
        //   document.querySelector('.antd-Table-content').style.height = `${this.scrollY + 46}px`
        //   // document.querySelector('.ant-table-body').style.height = `${this.scrollY + 46 - 62}px`
        // }
        
      })
    },
    // 打开编辑器
    handleEditMenuId(row) {
      console.log('打开编辑器>>>>', row)

      let url = window.location.origin
      if(process.env.VUE_APP_ROUTER_MODE=='hash') {
        url = url + '/#'
      }
      setTimeout(() => {
        open(url+'/amis?menuId=' + row.id + '&name=' + row.menuName)
      }, 100)
    },
    handleEdit(schema, menuId) {
      console.log('打开编辑器>>>', schema)
      this.$store.commit('SET_EDITAMISSCHEMA', schema)
      // this.editAmisSchema = JSON.parse(JSON.stringify(schema))
      console.log('打开编辑器>>>editAmisSchema>>>>', this.editAmisSchema)

      let url = window.location.origin
      if(process.env.VUE_APP_ROUTER_MODE=='mode') {
        url = url + '/#'
      }
      setTimeout(() => {
        open(url+'/amis?menuId=' + menuId)
        // this.$router.push({
        //   path: '/amis',
        //   query: {
        //     menuId
        //   }
        // })
      }, 100)
      // const routeUrl = this.$router.resolve('/amis')

      // window.open(routeUrl.href, "_blank")
    }
  }
}
